import React from 'react';

function HeaderTitle({title}) {
  return (
    <header>
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-8 mb-0 sm:mb-2">
          <div className="max-w-4xl mx-auto text-center px-2">
            <h1 className="text-4xl font-bold text-white mb-2">
              {title}
            </h1>
            <div className="w-24 h-1 bg-white mx-auto"></div>
          </div>
        </div>
      </header>
  );
}

export default HeaderTitle;
